export async function forgotPassword(body) {
   try {
      const req = await fetch(`${process.env.API_URL}/api/users/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
            ...body
        }),
      }).then((res) => res.json());

      console.log(req);
      return req;

    } catch (err) {
      console.log(err);
    }
}
